module.exports = __webpack_public_path__ + "img/menu_left_bar.38fcc1f6.png";